import {connect} from 'react-redux';
import React, {Component} from 'react';
import CopyButton from '../../cmp/CopyButton';
import CustomCouponModal from './CustomCouponModal';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router-dom';
import RenderDiscountValue from "../home/components/RenderDiscountValue";
// import {getCouponLink} from "../../../tools/func";

const mapStateToProps = (state) => {
    return {
        apply_discount_on_link: state.settings.apply_discount_on_link,
        my_coupons: state.settings.my_coupons || [],
        integration: state.settings.integration,
        website: state.settings.website,
        noCouponGiven: state.settings.locale_messages.noCouponGiven,
        account_status: state.settings.status,
        ref_code: state.settings.ref_code,
        coupon_change_allowed: state.settings.coupon_change_allowed === undefined ? true : state.settings.coupon_change_allowed
    }
}

class CouponRef extends Component {
    state = {
        show_coupon_modal: false
    }
    closeCouponModal = () => {
        this.setState({show_coupon_modal: false});
    }

    open = (coupon) => () => {
        this.setState({show_coupon_modal: true, editing_coupon: coupon});
    }

    render() {
        const {integration, website, account_status, my_coupons, apply_discount_on_link, ref_code} = this.props;
        return (<div className={'row align-items-center'}>
                <div className={'col'}>
                    <h4 className={'d-flex align-items-center'}><FormattedMessage id={'couponCode'}/>{
                        my_coupons.length === 1 && my_coupons[0].discount_value ?
                            <RenderDiscountValue coupon={my_coupons[0]}/> : null
                    }</h4>
                    <p className={'text-muted'}>
                        <FormattedMessage id={'couponCodeSubtitle'}/>
                    </p>
                    <CustomCouponModal onClose={this.closeCouponModal} editing_coupon={this.state.editing_coupon}
                                       visible={this.state.show_coupon_modal}/>
                    {
                        my_coupons && my_coupons.length > 0 ? my_coupons.map((item) => {
                            const {can_change, discount_value, link} = item;
                            const coupon = ['pending', 'blocked'].indexOf(account_status) < 0 ? item.coupon : item.coupon.replace(/./g, "*")
                            return <div className={'row align-items-center'} key={String(item.coupon)}>
                                <div className={'col-auto'}>
                                    <small>
                                        <FormattedMessage id={'couponCode'}/>
                                        {
                                            my_coupons.length > 1 && discount_value && <RenderDiscountValue coupon={item}/>
                                        }
                                    </small>
                                    <h4>{coupon}</h4>
                                    {
                                        can_change && account_status === 'approved' && this.props.coupon_change_allowed && (
                                            <div>
                                                <button className="btn btn-link px-0" onClick={this.open(coupon)}>
                                                    <FormattedMessage id={'changeCoupon'}/>
                                                </button>
                                            </div>)
                                    }
                                </div>
                                {
                                    account_status === 'approved' &&
                                    <div className={'col-auto'}>
                                        <CopyButton text={coupon}/>
                                    </div>
                                }


                                <div className="col-auto">
                                    {
                                        link &&
                                        <div>
                                            <CopyButton text={link} title={"Copy Shareable Link"}/>
                                        </div>
                                    }
                                </div>
                            </div>
                        }) : <p className={`alert alert-info ${!this.props.noCouponGiven && 'd-none'}`}>
                            <FormattedMessage id={'noCouponGiven'} values={
                                {
                                    contact_us: <Link to={'/contact'} className={'alert-link ml-1'}>
                                        <FormattedMessage id={'contactUs'}/>
                                    </Link>
                                }
                            }/>

                        </p>

                    }
                </div>
            </div>
        );
    }
}
//
// function RenderCouponLink({integration, website, coupon, ref_code}) {
//     if (!website) return null
//     const url = getCouponLink(integration, website, coupon, ref_code);
//     return url ? <CopyButton text={url} title={"Copy Shareable Link"}/> : null
// }

export default connect(mapStateToProps)(CouponRef);
